// Mock data for Around the World AI - Emergent clone

export const navLinks = [
  { label: 'SOUL Library', href: '/souls' },
  { label: 'Features', href: '#features' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Cost Breakdown', href: '#costs' },
  { label: 'FAQs', href: '#faqs' },
  { label: 'Enterprise', href: '#enterprise' },
];

export const showcaseSlides = [
  {
    laptop: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=1200&q=80&auto=format&fit=crop',
    mobile: 'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?w=600&q=80&auto=format&fit=crop',
    title: 'Movie Streaming'
  },
  {
    laptop: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1200&q=80&auto=format&fit=crop',
    mobile: 'https://images.unsplash.com/photo-1493612276216-ee3925520721?w=600&q=80&auto=format&fit=crop',
    title: 'Book Library'
  },
  {
    laptop: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80&auto=format&fit=crop',
    mobile: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&q=80&auto=format&fit=crop',
    title: 'Analytics Dashboard'
  },
  {
    laptop: 'https://images.unsplash.com/photo-1522542550221-31fd19575a2d?w=1200&q=80&auto=format&fit=crop',
    mobile: 'https://images.unsplash.com/photo-1526045478516-99145907023c?w=600&q=80&auto=format&fit=crop',
    title: 'Health Tracker'
  },
];

export const featureBlocks = [
  {
    id: 'web-mobile',
    icon: 'Monitor',
    title: 'Build websites and mobile apps',
    description: 'Transform your ideas into fully functional websites and mobile apps with instant deployment, seamless data connections, and powerful scalability.',
    image: 'https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?w=1000&q=80&auto=format&fit=crop'
  },
  {
    id: 'agents',
    icon: 'Bot',
    title: 'Build custom AI agents',
    description: 'Design intelligent agents that automate workflows, answer questions, and take actions across the web — all through natural language.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1000&q=80&auto=format&fit=crop'
  },
  {
    id: 'integrations',
    icon: 'Plug',
    title: 'Build powerful integrations',
    description: 'Connect to 100+ APIs, databases, payment gateways, and third-party services with zero configuration.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1000&q=80&auto=format&fit=crop'
  },
];

export const capabilities = [
  { icon: 'Code2', title: 'Full-Stack Code Generation', desc: 'React, FastAPI, Node.js, Python — write & ship complete apps.' },
  { icon: 'Database', title: 'Managed Databases', desc: 'MongoDB, Postgres, SQLite provisioned & wired up automatically.' },
  { icon: 'Sparkles', title: 'Multi-Model LLMs', desc: 'GPT-5, Claude Sonnet 4.5, Gemini 2.5 — pick or auto-route.' },
  { icon: 'Image', title: 'Image Generation', desc: 'Nano Banana & GPT-Image-1 built in for logos, art, avatars.' },
  { icon: 'Mic', title: 'Voice & Speech', desc: 'Text-to-speech and speech-to-text via ElevenLabs & Whisper.' },
  { icon: 'ShieldCheck', title: 'Auth & Payments', desc: 'Google/Apple SSO, Stripe, PayPal — integrated in one click.' },
  { icon: 'Rocket', title: 'One-Click Deploy', desc: 'Ship to a global CDN with a custom domain in seconds.' },
  { icon: 'GitBranch', title: 'GitHub Sync', desc: 'Two-way sync with your repos. Own your code, always.' },
  { icon: 'Globe2', title: 'Global Edge Runtime', desc: 'Serve users worldwide with sub-100ms response times.' },
];

export const creditPlans = [
  {
    name: 'Free',
    icon: 'Gift',
    price: 0,
    priceAnnual: 0,
    credits: 10,
    tag: 'Try Around the World AI at no cost',
    features: [
      '10 credits (one-time)',
      'Community support',
      'Public projects only',
      'Around the World AI branding on deploys',
    ],
    cta: 'Start Free',
    highlight: false,
  },
  {
    name: 'Standard',
    icon: 'Compass',
    price: 20,
    priceAnnual: 17,
    credits: 100,
    tag: 'Perfect for first-time builders',
    features: [
      '100 credits / month',
      'Private projects',
      'Deploy 1 app included (50 credits)',
      'Custom domains',
      'Priority email support',
    ],
    cta: 'Choose Standard',
    highlight: false,
  },
  {
    name: 'Pro',
    icon: 'Sparkles',
    price: 100,
    priceAnnual: 84,
    credits: 550,
    tag: 'Ship serious apps every week',
    features: [
      '550 credits / month',
      'Deploy up to 5 apps',
      'Remove Around the World AI branding',
      'Unlimited custom domains',
      'Dedicated support',
      'Advanced analytics',
    ],
    cta: 'Go Pro',
    highlight: true,
  },
  {
    name: 'Scale',
    icon: 'Rocket',
    price: 500,
    priceAnnual: 420,
    credits: 3000,
    tag: 'For agencies and heavy builders',
    features: [
      '3,000 credits / month',
      'Deploy up to 100 apps',
      'Team seats (5 members)',
      'Bring-your-own Stripe merchant',
      'Priority AI queue',
      '99.99% uptime SLA',
    ],
    cta: 'Choose Scale',
    highlight: false,
  },
];

export const creditCosts = [
  { action: 'One AI conversation turn', cost: 1 },
  { action: 'Generate an image (Nano Banana)', cost: 2 },
  { action: 'Full app blueprint generation', cost: 3 },
  { action: 'Deploy an app (per month)', cost: 50 },
  { action: 'Custom domain linking', cost: 0 },
  { action: 'GitHub sync', cost: 0 },
];

export const pricingPlans = [
  {
    name: 'Free',
    icon: 'Gift',
    tag: 'Get started with essential features at no cost',
    price: 0,
    priceAnnual: 0,
    features: [
      '25 messages / month',
      'Community support',
      'Public projects only',
      'Around the World AI branding',
    ],
    cta: 'Start Free',
    highlight: false,
  },
  {
    name: 'Standard',
    icon: 'Compass',
    tag: 'Perfect for first-time builders',
    price: 20,
    priceAnnual: 17,
    features: [
      '500 messages / month',
      'Private projects',
      'Custom domains',
      'Priority email support',
      'All integrations',
    ],
    cta: 'Choose Standard',
    highlight: true,
  },
  {
    name: 'Pro',
    icon: 'Sparkles',
    tag: 'Built for serious creators and brands',
    price: 200,
    priceAnnual: 167,
    features: [
      '5,000 messages / month',
      'Unlimited projects',
      'Team collaboration (5 seats)',
      'Advanced analytics',
      'Dedicated support',
    ],
    cta: 'Go Pro',
    highlight: false,
  },
];

export const monthlyToolCosts = [
  { category: 'LLM APIs', name: 'OpenAI (GPT-5, GPT-Image-1)', minCost: 60, maxCost: 400, note: 'Text + image generation. Pay per token.' },
  { category: 'LLM APIs', name: 'Anthropic Claude Sonnet 4.5', minCost: 40, maxCost: 300, note: 'Long-context reasoning + coding.' },
  { category: 'LLM APIs', name: 'Google Gemini 2.5 + Nano Banana', minCost: 30, maxCost: 200, note: 'Fast multimodal + image gen.' },
  { category: 'Infrastructure', name: 'Cloud Hosting (AWS / GCP)', minCost: 80, maxCost: 500, note: 'Kubernetes + load balancers.' },
  { category: 'Infrastructure', name: 'MongoDB Atlas', minCost: 25, maxCost: 200, note: 'Managed database cluster.' },
  { category: 'Infrastructure', name: 'CDN & Storage (Cloudflare + S3)', minCost: 20, maxCost: 150, note: 'Static assets + edge cache.' },
  { category: 'Developer Tools', name: 'GitHub Enterprise', minCost: 21, maxCost: 21, note: 'Per user / month.' },
  { category: 'Developer Tools', name: 'Vercel / Netlify (edge preview)', minCost: 20, maxCost: 150, note: 'Preview + edge functions.' },
  { category: 'Developer Tools', name: 'Sentry / Datadog (Monitoring)', minCost: 26, maxCost: 200, note: 'Errors, logs, APM.' },
  { category: 'Integrations', name: 'Stripe (Payments)', minCost: 0, maxCost: 0, note: '2.9% + 30¢ per transaction (variable).' },
  { category: 'Integrations', name: 'SendGrid / Postmark (Email)', minCost: 15, maxCost: 90, note: 'Transactional email.' },
  { category: 'Integrations', name: 'Twilio (SMS / Voice)', minCost: 10, maxCost: 100, note: 'Per message / minute pricing.' },
  { category: 'Integrations', name: 'ElevenLabs (TTS)', minCost: 22, maxCost: 99, note: 'Voice cloning + TTS.' },
  { category: 'Team & Ops', name: 'Slack + Notion + Linear', minCost: 30, maxCost: 90, note: 'Communication & project mgmt.' },
  { category: 'Team & Ops', name: 'Google Workspace', minCost: 12, maxCost: 18, note: 'Per user / month.' },
];

export const testimonials = [
  {
    name: 'Aarav Mehta',
    role: 'Founder, Nomad Stays',
    avatar: 'https://i.pravatar.cc/120?img=12',
    text: 'I built and launched a booking marketplace in 4 days. Around the World AI wrote the backend, generated the images, and shipped it to production.'
  },
  {
    name: 'Sofia Alvarez',
    role: 'Indie Maker',
    avatar: 'https://i.pravatar.cc/120?img=32',
    text: 'The multi-model routing is magical. I never think about which LLM to use — it just picks the best one for the job.'
  },
  {
    name: 'Kenji Watanabe',
    role: 'CTO, LeafLabs',
    avatar: 'https://i.pravatar.cc/120?img=52',
    text: 'We replaced three vendors with Around the World AI. Auth, database, deploy — all wired up in the same conversation.'
  },
  {
    name: 'Priya Nair',
    role: 'Product Designer',
    avatar: 'https://i.pravatar.cc/120?img=45',
    text: 'Designer with no backend experience here. I shipped a full-stack fitness tracker to my friends in a weekend.'
  },
];

export const faqs = [
  {
    q: 'What exactly is Around the World AI?',
    a: 'It is an AI-powered full-stack development platform. Describe the app you want in plain English and our agents write the code, provision the database, generate assets and deploy the project globally.'
  },
  {
    q: 'Do I own the code that gets generated?',
    a: 'Yes. Every project can be synced to your own GitHub repository. The code is yours, forever, under a permissive license.'
  },
  {
    q: 'Which LLMs do you support?',
    a: 'OpenAI GPT-5 family, Anthropic Claude Sonnet 4.5, Google Gemini 2.5, and Nano Banana for image generation. You can bring your own API keys or use our universal key.'
  },
  {
    q: 'How does billing work?',
    a: 'You choose a plan (Free, Standard, Pro or Enterprise) that includes a monthly message quota. Overages are pay-as-you-go. Cancel anytime.'
  },
  {
    q: 'Can I self-host or deploy elsewhere?',
    a: 'Yes. Every project can be exported and deployed to Vercel, Railway, AWS, GCP, or your own Kubernetes cluster.'
  },
  {
    q: 'How much would it cost me to run a platform like this myself?',
    a: 'See the Cost Breakdown section below — running an equivalent platform yourself typically ranges from $400 (lean solo dev) to $2,500+ per month at scale.'
  },
];

export const stats = [
  { number: '10M+', label: 'apps launched' },
  { number: '190+', label: 'countries served' },
  { number: '4 min', label: 'avg. build time' },
  { number: '99.9%', label: 'uptime SLA' },
];

export const enterpriseFeatures = [
  'Dedicated cluster with private networking',
  'SOC 2 + GDPR + HIPAA compliance',
  'SSO with Okta, Azure AD, Google Workspace',
  'Custom SLAs and 24/7 dedicated support',
  'Unlimited seats and projects',
  'On-premise deployment available',
];
